import React from 'react';
import './Hero.css';
import { CONTACT_INFO } from '../constants';

function Hero() {
  const handleStartBooking = () => {
    const phoneNumber = CONTACT_INFO.PHONE.VALUE;
    const whatsappMessage = CONTACT_INFO.WHATSAPP.MESSAGE;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="trust-badge">
          <span className="stars">⭐⭐⭐⭐⭐</span>
          <span className="rating-text">Rated 4.9/5 by 50,000+ Customers</span>
        </div>
        <h1 className="hero-title">
          Book Newspaper Ads Online at Lowest Rates
        </h1>
        <p className="hero-subtitle">
          Reach millions of readers across India with our hassle-free ad booking service
        </p>
        <button className="cta-button" onClick={handleStartBooking}>
          Start Booking
        </button>
        
        <div className="hero-features">
          <div className="feature-badge">
            <span className="badge-icon">✓</span>
            <span>Instant Booking</span>
          </div>
          <div className="feature-badge">
            <span className="badge-icon">✓</span>
            <span>Best Price Guarantee</span>
          </div>
          <div className="feature-badge">
            <span className="badge-icon">✓</span>
            <span>24/7 Support</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
